import { render, staticRenderFns } from "./misrepresentation.vue?vue&type=template&id=36d06656&scoped=true"
import script from "./misrepresentation.vue?vue&type=script&lang=js"
export * from "./misrepresentation.vue?vue&type=script&lang=js"
import style0 from "./misrepresentation.vue?vue&type=style&index=0&id=36d06656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d06656",
  null
  
)

export default component.exports